module.exports = __webpack_public_path__ + "static/media/restore_site_id.c095b0d6.png";